export const PublishActionModalNames = {
  PUBLISH_CONFIRM: 'publishConfirm',
  UNPUBLISH_CONFIRM: 'unpublishConfirm',
  WARNINGS_AND_SUGGESTIONS: 'warningsAndSuggestions',
  SCHEDULING_OPTIONS: 'schedulingOptions',
  CANCEL_SCHEDULE: 'cancelSchedule'
};